import { yupResolver } from "@hookform/resolvers/yup";
import CloseIcon from "@mui/icons-material/Close";
import RightArrowIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  IconButton,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { FILE_SIZE } from "../../common/constants";
import { getFormattedUrl } from "../../common/utils";
import CButton from "../../components/CButton";
import CFormProvider from "../../components/CFormProvider";
import CFormTextField from "../../components/CFormTextField";
import JoditEditor from "jodit-react";
import he from "he";
import { fetchAllModule } from "../../slices/moduleSlice";
import { fetchAllTasks } from "../../slices/taskSlice";
import {
  getAssignmentDetails,
  updateAssignmentDetails,
} from "../../slices/assignment";

const EditAssignment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { assignmentId } = useParams();
  const { moduleList } = useSelector((state) => state.module);
  const { taskList } = useSelector((state) => state.task);
  const { assignmentDetails } = useSelector((state) => state.assignment);

  const [selectedModule, setSelectedModule] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [qusTask, setQusTask] = useState([]);
  const [defaultValues, setDefaultValues] = useState({
    title: "",
    moduleId: null,
    taskId: null,
  });

  const AssignmentSchema = Yup.object().shape({
    title: Yup.string().required("Assignment question is required"),
    moduleId: Yup.mixed().required("Module is required"),
    taskId: Yup.mixed().required("Task is required"),
  });

  const methods = useForm({
    resolver: yupResolver(AssignmentSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = methods;

  useEffect(() => {
    const fetchAllModuleAPI = () => {
      let payload = {
        page: 1,
        limit: -1,
      };
      dispatch(fetchAllModule(payload));
      setSelectedTask(null);
    };

    fetchAllModuleAPI();
  }, [dispatch]);

  useEffect(() => {
    if (assignmentDetails) {
      let taskData = {
        moduleId: assignmentDetails?.module?._id,
        taskId: assignmentDetails?.task?._id,
        title: assignmentDetails?.title,
      };
      setDefaultValues(taskData);
      moduleList && setSelectedModule(assignmentDetails?.module?._id);
      taskList && setSelectedTask(assignmentDetails?.task?._id);
    }
  }, [assignmentDetails]);

  useEffect(() => {
    methods.reset(defaultValues);
  }, [defaultValues, reset, methods]);

  useEffect(() => {
    const QusList = taskList.filter((data) => data.taskType == "Question");
    setQusTask(QusList);
  }, [taskList]);

  useEffect(() => {
    if (selectedModule !== null) {
      let payload = {
        page: 1,
        limit: -1,
        moduleId: selectedModule,
      };
      dispatch(fetchAllTasks(payload));
    }
  }, [selectedModule]);

  useEffect(() => {
    dispatch(getAssignmentDetails(assignmentId));
  }, [dispatch, assignmentId]);

  const Placeholder = ({ children }) => {
    return <div>{children}</div>;
  };

  const onSubmit = (values) => {
    const data = {
      title: values.title,
      module: selectedModule,
      task: selectedTask,
    };
    const editPayload = {
      id: assignmentId,
      payload: data,
    };
    dispatch(updateAssignmentDetails(editPayload)).then((res) => {
      if (!res.error) {
        navigate("/assignment-list");
      }
    });
  };

  return (
    <>
      <div className="main-content company-sec">
        <div className="breadcrumb-back">
          <CButton
            sx={{ border: " 0 !important" }}
            onClick={() => navigate("/assignment-list")}
            className="btn-text"
          >
            <RightArrowIcon />
          </CButton>
          <h2>Edit Assignment</h2>
        </div>
        <div className="setting-content">
          <div className="card-box col-right">
            <div className="company-form">
              <CFormProvider
                methods={methods}
                onSubmit={handleSubmit(onSubmit)}
              >
                <FormControl fullWidth className="CSelect">
                  <InputLabel id="demo-simple-select-label">
                    Select Module
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="Select Module"
                    name="moduleId"
                    id="demo-simple-select"
                    displayEmpty
                    renderValue={
                      selectedModule !== null
                        ? undefined
                        : () => <Placeholder>Select Module</Placeholder>
                    }
                    onChange={(e) => {
                      setSelectedModule(e.target.value);
                      setValue("moduleId", e.target.value);
                      setSelectedTask(null);
                      setValue("taskId", null);
                    }}
                    value={selectedModule || ""}
                    inputlabelprops={{ shrink: true }}
                  >
                    {moduleList?.map((data) => (
                      <MenuItem key={data._id} value={data._id}>
                        {data?.title}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.moduleId && (
                  <FormHelperText>{errors.moduleId.message}</FormHelperText>
                )}
                </FormControl>
               

                <FormControl fullWidth className="CSelect">
                  <InputLabel id="demo-simple-select-label">
                    Select Task
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="Select Module"
                    name="moduleId"
                    id="demo-simple-select"
                    displayEmpty
                    renderValue={
                      selectedTask !== null
                        ? undefined
                        : () => <Placeholder>Select Task</Placeholder>
                    }
                    onChange={(e) => {
                      setSelectedTask(e.target?.value);
                      setValue("taskId", e.target?.value);
                    }}
                    value={selectedTask || ""}
                    inputlabelprops={{ shrink: true }}
                  >
                    {qusTask?.map((data) => (
                      <MenuItem key={data._id} value={data._id}>
                        {data?.title}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.taskId && (
                  <FormHelperText>{errors.taskId.message}</FormHelperText>
                )}

                </FormControl>
                
                <CFormTextField
                  label="Question"
                  name="title"
                  InputLabelProps={{ shrink: true }}
                />

                <div className="company-details-update">
                  <CButton
                    onClick={handleSubmit(onSubmit)}
                    className="btn-primary"
                  >
                    Submit
                  </CButton>
                </div>
              </CFormProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditAssignment;
